import get from 'lodash/get';
import set from 'lodash/set';
import { addMethod, mixed } from 'yup';

import { makeKey } from '../utils';

const _isEqual = (a, b) => {
  return a.toString() === b.toString();
};

addMethod(mixed, 'encode', function (_value, options) {
  const value = this.cast(_value, {
    applyConst: true,
    context: {},
    ...options,
  });
  if (value !== undefined) {
    return this.stringify(value, options);
  }
  return value;
});

addMethod(mixed, 'decode', function (_value, options) {
  const value = this.cast(_value, {
    parseConst: true,
    context: {},
    ...options,
  });
  if (value !== undefined) {
    return this.parse(value);
  }
  return value;
});

addMethod(mixed, '_isEqual', function (value, otherValue) {
  return value === otherValue;
});

addMethod(mixed, 'stripDefaults', function (options = {}) {
  const next = this.clone();
  const defaults =
    this._default !== undefined ? this.default() : options.defaults;

  return next
    .nullable()
    .default(undefined)
    .transform(function (value) {
      if (value !== undefined && this._isEqual(value, defaults)) {
        return null;
      }
      return value;
    });
});

addMethod(mixed, 'getZipNodes', function () {
  return [];
});

addMethod(mixed, 'log', function (msg) {
  const next = this.clone();
  next._log = msg || 'schema log';
  return next;
});

addMethod(mixed, 'stringify', function (value) {
  if (value === undefined) {
    return '';
  }

  return `${value}`;
});

addMethod(mixed, 'traverse', function (callback, options) {
  callback({
    field: this,
    node: options.parent,
    key: makeKey`${options.namespace}_${options.parent}`,
    getter: (source, indexes) => {
      const path = options.path.replace(/indexKey_\d+/g, (key) => {
        return indexes[key];
      });
      return get(source, path);
    },
    setter: (source, value, indexes = {}) => {
      const path = options.path.replace(/indexKey_\d+/g, (key) => {
        return indexes[key];
      });
      return set(source, path, value);
    },
  });
});

addMethod(mixed, 'parse', function (stringValue) {
  if (stringValue === '') {
    return;
  }
  try {
    return JSON.parse(stringValue);
  } catch (e) {
    return undefined;
  }
});

addMethod(mixed, 'applyConst', function (value) {
  if (!this._constants) {
    return value;
  }
  const constant = this._constants.find((constant) =>
    _isEqual(constant.value, value)
  );

  return constant ? constant.key : value;
});

addMethod(mixed, 'parseConst', function (value) {
  if (!this._constants) {
    return value;
  }
  const constant = this._constants.find((constant) =>
    _isEqual(constant.key, value)
  );
  return constant ? constant.value : value;
});

addMethod(mixed, 'constants', function (constants) {
  const next = this.clone();
  next._constants = constants;
  return next;
});

export default mixed;
